// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__3GfV2","infoBtn":"quickbooks_infoBtn__15iJW","formBox":"quickbooks_formBox__Rjp1J","formFooter":"quickbooks_formFooter__1JBNM"};